import { fabric } from 'fabric';

// Global canvas state manager to prevent race conditions
export class CanvasStateManager {
  private disposedCanvases = new WeakSet<fabric.Canvas>();
  private pendingOperations = new Set<string>();

  markCanvasDisposed(canvas: fabric.Canvas): void {
    this.disposedCanvases.add(canvas);
  }

  isCanvasDisposed(canvas: fabric.Canvas): boolean {
    return this.disposedCanvases.has(canvas);
  }

  addPendingOperation(operationId: string): void {
    this.pendingOperations.add(operationId);
  }

  removePendingOperation(operationId: string): void {
    this.pendingOperations.delete(operationId);
  }

  hasPendingOperations(): boolean {
    return this.pendingOperations.size > 0;
  }
}

let canvasStateManagerInstance: CanvasStateManager | null = null;

export const getCanvasStateManager = (): CanvasStateManager => {
  if (!canvasStateManagerInstance) {
    canvasStateManagerInstance = new CanvasStateManager();
  }

  return canvasStateManagerInstance;
};
